//@ts-nocheck

import React from "react";
import { useController } from "react-hook-form";
import type { Control } from "react-hook-form";
import type { TRule } from "@/comn/hooks";
import { useToast } from "@/comn/hooks";
import { Icon } from "../Icon";

export type ControllerWrapperProps = TRule & {
    children: React.ReactElement;
    control?: Control;
    name?: string;
    onBlur?: any;
    onChange?: any;
    defaultValue?: any;
};

export const ControllerWrapper = (props: ControllerWrapperProps) => {
    const {
        children,
        control,
        name,
        onBlur,
        onChange,
        defaultValue,

        // rule
        min,
        max,
        minLength,
        maxLength,
        required,
        pattern,
        validate,
        copy = true,
        ...rest
    } = props;

    // msg.00005

    const { showToast } = useToast();

    const { field } = useController({
        name,
        control,
        defaultValue,
        rules: {
            min,
            max,
            minLength,
            maxLength,
            required: required ? "msg.com.00005" : undefined,
            pattern,
            validate,
            onChange: (event) => {
                if (!onChange) return;
                if (!event.target) return;
                onChange(event.target.value);
            },
            onBlur: (event) => {
                if (!onBlur) return;
                if (!event.target) return;
                onBlur(event.target);
            },
        },
    });

    return (
        <>
            {React.cloneElement(children, {
                ...field,
                ...rest,
                maxLength,
            })}
            {window.location.protocol === "https:" && props.edit === false && copy && (
                <button
                    className="hidden absolute left-full top-1/2 -translate-y-1/2 pl-1 py-1 hover:text-gray group-hover/control:block"
                    onClick={(e) => {
                        e.preventDefault();
                        try {
                            window.navigator.clipboard.writeText(field.value || "");
                            showToast({ content: "L_CPY", type: "info" });
                        } catch (error) {}
                    }}
                >
                    <Icon icon="clipboard" size="xs" />
                </button>
            )}
        </>
    );
};
